enum NameEnum {
    PASSWORD_SET = "PasswordSet",
    PASSWORD_OTP = "PasswordOtp",
    PASSWORD_RESULT = "PasswordResult",
    PASSWORD_ERROR = "PasswordError",
    PASSWORD_PHONE = "PasswordPhone",
    PASSWORD_VERIFY_PHONE = "PasswordVerifyPhone",
    LOGIN = "Login",
    LOGIN_OTP = "LoginOtp",
    LOGIN_CONSENT = "LoginConsent",
    LOGIN_ERROR = "LoginError",
    LOGIN_PHONE = "LoginPhone",
    LOGIN_VERIFY_PHONE = "LoginVerifyPhone",
    CONTRACT_WITHDRAWAL = "ContractWithdrawal",
    CONTRACT_WITHDRAWAL_EMAIL = "ContractWithdrawalEmail",
    CONTRACT_WITHDRAWAL_ERROR = "ContractWithdrawalError",
    CONTRACT_WITHDRAWAL_OTP = "ContractWithdrawalOtp",
    CONTRACT_WITHDRAWAL_PHONE = "ContractWithdrawalPhone",
    CONTRACT_WITHDRAWAL_RESULT = "ContractWithdrawalResult"
}

export default NameEnum;
